import { Component, Input } from '@angular/core'
import { Job, JobStatus, PipelineType } from '../../../shared/model/jobs'

@Component({
    selector: 'app-job-status-group',
    templateUrl: './job-status-group.component.html',
    styleUrls: ['./job-status-group.component.scss'],
})
export class JobStatusGroupComponent {
    JobStatusEnum = JobStatus

    @Input() jobs: Job[] | undefined
    @Input() title: string | undefined

    appendTypeToName(job: Job): any {
        if (job.type === PipelineType.tsneClustering) {
            return `[TSNE] ${job.name}`
        }
        if (job.type === PipelineType.umapClustering) {
            return `[UMAP] ${job.name}`
        }
        return job.name
    }
}
